import { useLayoutEffect } from 'react';
import {
  bindPromptHighlightOverlaySync,
  syncPromptHighlightScroll,
} from '../utils/promptHighlightOverlay';

/** 为工作台 / 重新生成等多提示词场景绑定高亮层 scroll / resize 同步。 */
export function usePromptHighlightOverlayBindings(
  promptIds: number[],
  promptTexts: string[],
  promptInputRefs: React.MutableRefObject<Record<number, HTMLTextAreaElement | null>>,
  promptHighlightRefs: React.MutableRefObject<Record<number, HTMLDivElement | null>>,
): void {
  const idKey = promptIds.join(',');
  const textKey = promptTexts.join('\0');

  useLayoutEffect(() => {
    const cleanups: Array<() => void> = [];
    for (const id of promptIds) {
      const ta = promptInputRefs.current[id];
      const hi = promptHighlightRefs.current[id];
      if (ta && hi) cleanups.push(bindPromptHighlightOverlaySync(ta, hi));
    }
    return () => cleanups.forEach((c) => c());
  }, [idKey, promptInputRefs, promptHighlightRefs]);

  useLayoutEffect(() => {
    for (const id of promptIds) {
      syncPromptHighlightScroll(promptInputRefs.current[id], promptHighlightRefs.current[id]);
    }
  }, [idKey, textKey, promptInputRefs, promptHighlightRefs]);
}
